import { useState } from "react";
import { Button, TextInput } from "./components";
import OrderService from "./services/endpoints/order";
import { toast } from "react-toastify";

interface IProps {
  id: number;
  onClose: () => void;
  onSuccess: () => void;
}

const FillOrderModalUI = ({ id, onClose, onSuccess }: IProps) => {
  const [executedVolume, setExecutedVolume] = useState("");

  const clickHandler = () => {
    const volume = Number(executedVolume);
    if (!Number.isFinite(volume) || volume <= 0) {
      toast.error("Volume must be a positive number");
      return;
    }

    OrderService.fillOrder({ id, executedVolume: volume })
      .then((response) => {
        if (response?.isSuccess === false || response?.data === false) {
          throw new Error(response?.message || "Fill order failed");
        }
        toast.success("Fill Order Edited successfully");
        onClose();
        onSuccess();
      })
      .catch(() => toast.error("something is wrong!"));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-5">
      <TextInput
        onChange={setExecutedVolume}
        value={executedVolume}
        label="Volume"
      />
      <Button
        label="Execute"
        onClick={clickHandler}
        disabled={!executedVolume}
      />
    </div>
  );
};

export default FillOrderModalUI;
